<template>
  <el-dialog
    :visible="visible"
    :close-on-click-modal="false"
    title="请完成验证码"
    @close="handleClose"
    width="500px"
  >
    <el-divider></el-divider>
    <el-form :model="newParams" :rules="paramsRules" ref="codeForm" label-width="100px" style="margin:40px">
      <el-form-item prop="code">
        <div _flex="~ items-center" _p="t-20px">
          <el-input
            ref="codeInput"
            v-model="newParams.code"
            oninput="value=value.trim()"
            :maxlength="5"
            @keydown.enter.native.prevent="handleConfirm"
            placeholder="请输入图中的字符"
            class="w-220"
          ></el-input>
          <img :src="`${img.url}?time=${img.time}&token=${token}`" _w="200px" _m="l-15px">
        </div>
      </el-form-item>
      <span _m="t-10px l-230px b-10px" _text="[#9A9A9A]" _cursor="pointer" @click="() => { img.time = new Date().getTime(), token = getUUID() }">看不清？换一张</span>
    </el-form>
    <el-divider></el-divider>
    <div style="margin-top: 20px; margin-bottom: 20px; display: flex; align-items: center; justify-content: center;">
      <el-button class="btn-close" @click="handleClose" style="width: 80px; height: 32px; line-height: 1px;" >取 消</el-button>
      <el-button class="btn-prim" @click="handleConfirm" type="primary" style="width: 80px; height: 32px; line-height: 1px;">确定</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { last } from 'lodash'
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    confirm: {
      type: Function,
      default: () => {}
    }
  },
  model: {
    prop: 'visible',
    event: 'update:visible'
  },
  data() {
    return {
      newParams: {
        code: ''
      },
      img: {
        url: '',
        time: ''
      },
      paramsRules: {
        code: [
          { required: true, message: '请输入验证码', trigger: ['blur', 'change'] },
          { min: 5, max: 5, message: '长度为5', trigger: ['blur', 'change'] }
        ]
      },
      token: ''
    }
  },
  watch: {
    visible(val) {
      if (val) {
        try {
          this.newParams.code = ''
          this.$refs['codeForm']?.resetFields()
          this.token = this.getUUID()
          this.$nextTick(() => {
            this.$refs.codeInput?.focus()
          })
        } catch(err) {
          console.log('codeTest', err)
        }

      }
    }
  },
  mounted() {
    this.img.url = window.web_config.api_url + '/verify'
    this.token = this.getUUID()
  },
  methods: {
    getUUID() {
      const tempURL = URL.createObjectURL(new Blob())
      const uuid = tempURL.toString()
      URL.revokeObjectURL(tempURL)
      return last(uuid.split('/')).split('-')[0]
    },
    handleClose() {
      this.$emit('update:visible', false)
    },
    handleConfirm() {
      this.$refs['codeForm'].validate(valid => {
        if (valid) {
          this.confirm('', this.token + ',' + this.newParams.code)
          this.handleClose()
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.w-220 {
  width: 220px;
}
/deep/ .el-form-item__content {
  margin-left: 0px !important;
}
/deep/ .el-form-item{
  margin-bottom: 0px !important;
}
</style>
